export default __webpack_public_path__ + "static/media/speaker.35a8605a.svg";